/// <amd-module name="Test/TestPlansHubRefresh/TestPlanClonePanel/TestPlanClonePanelConstants" />

export namespace TestPlanClonePanelConstants {
    export const contributionId = "ms.vss-test-web.testplans-hub-refresh-route";
    export const queryParams = "?planId={0}&opId={1}";
    export const referRadioButtonType = "Refer";
    export const cloneRadioButtonType = "Clone";
    export const AreaPathIterationDepth = 15;
    export const ToastDurationMS = 8000;
}
